/** Shared launch configuration defaults for schedule emit and play. */

export const DEFAULT_LAUNCH_DATE = '2026-11-13';

/** Cards (and trail hubs) per daily puzzle. */
export const CARDS_PER_DAY = 6;
